import React, { useState, useEffect } from 'react';
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Bar, Cell } from 'recharts';

export default function ResponsiveBarChart({ barData, COLORS, onBarClick, activeKey }) {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 600);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const formatXAxis = (tickItem) => {
        if (isMobile && tickItem.length > 8) return `${tickItem.substring(0, 6)}...`;
        return tickItem;
    };

    const handleClick = (data) => {
        if (onBarClick && data?.activePayload?.[0]?.payload) {
            onBarClick(data.activePayload[0].payload);
        }
    };

    return (
        <div style={{ width: '100%', overflow: 'hidden' }}>
            <ResponsiveContainer width="100%" height={isMobile ? 250 : 300}>
                <BarChart
                    data={barData}
                    onClick={handleClick}
                    style={{ cursor: onBarClick ? 'pointer' : 'default' }}
                    margin={{
                        top: 10,
                        right: isMobile ? 10 : 20,
                        left: isMobile ? -20 : 0,
                        bottom: isMobile ? 35 : 10,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" vertical={false} />
                    <XAxis
                        dataKey="name"
                        tickFormatter={formatXAxis}
                        tick={{
                            fontSize: 10,
                            fill: 'var(--text-muted)',
                            angle: isMobile ? -45 : 0,
                            textAnchor: isMobile ? 'end' : 'middle',
                        }}
                        interval={0}
                    />
                    <YAxis
                        allowDecimals={false}
                        tick={{ fontSize: 11, fill: 'var(--text-muted)' }}
                        width={isMobile ? 35 : 40}
                    />
                    <Tooltip
                        cursor={{ fill: 'rgba(0,0,0,0.04)' }}
                        contentStyle={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 8 }}
                    />
                    <Bar dataKey="count" radius={[4, 4, 0, 0]}>
                        {barData.map((entry) => (
                            <Cell
                                key={entry.key}
                                fill={COLORS[entry.key] || '#3b82f6'}
                                // Dim non-active bars when a filter is active
                                opacity={activeKey && activeKey !== entry.key ? 0.25 : 1}
                                stroke={activeKey === entry.key ? COLORS[entry.key] : 'none'}
                                strokeWidth={activeKey === entry.key ? 2 : 0}
                            />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}